
import { ISavedAddressType } from "../types";
import { firebase } from "../config/firebase.client";
import { onValue, update, remove, push, set } from "firebase/database";
import { ADM_SAVED_ADDRESSES_ADD, ADM_SAVED_ADDRESSES_EDIT, ADM_SAVED_ADDRESSES_FETCH, ADM_SAVED_ADDRESSES_ERROR, ADM_SAVED_ADDRESSES_REMOVE } from "../store/types";

export const fetchAdmSavedAddresses = () => async (dispatch: any) => {
    const { admSavedAddressesRef } = firebase;
    try {

        const snapshot: any = await new Promise((resolve, reject) => {
            onValue(admSavedAddressesRef, (snapshot) => {
                resolve(snapshot);
            }, {
                onlyOnce: true
            });
        });

        if (snapshot.exists()) {
            const admSavedAddressesData = snapshot.val();

            const admSavedAddressesDataArray = Object.keys(admSavedAddressesData).map((key) => ({
                ...admSavedAddressesData[key],
                id: key,
            }));

            admSavedAddressesDataArray.sort((a, b) => b.createdAt - a.createdAt);


            dispatch({
                type: ADM_SAVED_ADDRESSES_FETCH,
                payload: admSavedAddressesDataArray,
            });
        } else {
            throw new Error('Document not found');
        }
    } catch (error: any) {
        console.error('Error fetching admSavedAddresses data:', error);
        dispatch({
            type: ADM_SAVED_ADDRESSES_ERROR,
            payload: error.message,
        });
    }
};

export const editAdmSavedAddresses = (admSavedAddressesItem: ISavedAddressType, method: "Add" | "Delete" | "Update") => async (dispatch: any) => {
    const { admSavedAddressesAddRef, admSavedAddressesEditRef } = firebase;

    if (method === "Add") {
        const newAdRef = push(admSavedAddressesAddRef);
        const newAdData = { ...admSavedAddressesItem, id: newAdRef.key, };


        set(newAdRef, newAdData);

        dispatch({
            type: ADM_SAVED_ADDRESSES_ADD,
            payload: newAdData,
        });

    }
    else if (method === "Delete") {
        remove(admSavedAddressesEditRef(admSavedAddressesItem.id!));

        dispatch({
            type: ADM_SAVED_ADDRESSES_REMOVE,
            payload: admSavedAddressesItem,
        });
    }
    else if (method === "Update") {
        update(admSavedAddressesEditRef(admSavedAddressesItem.id!), admSavedAddressesItem);

        dispatch({
            type: ADM_SAVED_ADDRESSES_EDIT,
            payload: admSavedAddressesItem,
        });
    }
};